<template>
  <div class="answer-detail-person" :class="{theme: type === '1'}">
    <template v-if="type === '1'">
      <div class="option-list">
        <div
          @click="change(option.eventExamOptionsId)"
          class="option-item"
          :class="{active: option.eventExamOptionsId === currentOption}"
          v-for="(option, index) in optionsList"
          :key="index"
        >
          {{ option.name }}
        </div>
      </div>
      <div class="choose-list">
        <div class="choose-item" v-for="(item, index) in chooseList" :key="index">
          <img v-if="item.user_face" :src="$isCdn(item.user_face)" alt="" />
          <img v-else src="./../../../assets/image/user.png" alt="" />
          <div class="name van-ellipsis">{{ item.user_name ? item.user_name : '游客_' + item.user_id }}</div>
          <div class="org van-ellipsis">{{ item.organization_name ? item.organization_name : '' }}</div>
        </div>
      </div>
    </template>
    <div v-else class="answer-list">
      <div class="answer-item" v-for="(item, index) in answerList" :key="index">
        <div class="answer-item-head">
          <img v-if="item.user_face" :src="$isCdn(item.user_face)" alt="" />
          <img v-else src="./../../../assets/image/user.png" alt="" />
          <div class="name van-ellipsis">{{ item.user_name ? item.user_name : '游客_' + item.user_id }}</div>
          <div class="org van-ellipsis">{{ item.organization_name ? item.organization_name : '' }}</div>
        </div>
        <div class="answer-content">
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getoptions, getchoose, getanswer} from '@/api'
export default {
  data() {
    return {
      type: this.$route.query.type, // 1选项题 2问答题
      id: this.$route.params.id,
      titleId: this.$route.query.titleId,
      optionId: this.$route.query.optionId,
      currPage: 1,
      pageSize: 1000,
      optionsList: [],
      chooseList: [],
      currentOption: this.$route.query.optionId,
      answerList: []
    }
  },
  created() {
    if (this.type === '1') {
      this.initOptions()
      this.initChoose()
    } else {
      this.initAnswer()
    }
  },
  methods: {
    async initOptions() {
      const params = {
        titleId: this.titleId
      }
      const result = await getoptions(params)
      if (result.code === 0) {
        this.optionsList = result.data
      }
    },
    async initChoose() {
      const params = {
        eventId: this.id,
        currPage: this.currPage,
        pageSize: this.pageSize,
        optionId: this.currentOption,
        titleId: this.titleId
      }
      const result = await getchoose(params)
      if (result.code === 0) {
        this.chooseList = result.data.records
      }
    },
    async initAnswer() {
      const params = {
        currPage: this.currPage,
        pageSize: this.pageSize,
        titleId: this.titleId
      }
      const result = await getanswer(params)
      if (result.code === 0) {
        this.answerList = result.data.records
      }
    },
    change(option) {
      this.currentOption = option
      this.initChoose()
    }
  }
}
</script>

<style scoped lang="scss">
.answer-detail-person {
  padding: 10px;
  min-height: 100vh;
  &.theme {
    background: #fff;
  }
}
.option-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  .option-item {
    margin: 4px;
    width: 50px;
    height: 30px;
    border-radius: 16px;
    background: #f1f3f6;
    text-align: center;
    line-height: 30px;
    &.active {
      background: rgba(68, 101, 243, 0.24);
      color: rgba(68, 101, 243, 1);
    }
  }
}

.choose-item + .choose-item {
  margin-top: 14px;
}
.choose-item {
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .name {
    font-weight: 700;
    color: #303133;
    margin: 0 12px;
    max-width: 160px;
    display: inline-block;
  }
  .org {
    color: #909399;
    flex: 1;
  }
}

.answer-item + .answer-item {
  margin-top: 14px;
}

.answer-item {
  border-radius: 10px;
  padding: 16px;
  background: #fff;
}

.answer-item-head {
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .name {
    color: #606266;
    margin: 0 12px;
    max-width: 160px;
    display: inline-block;
  }
  .org {
    color: #909399;
    flex: 1;
  }
}

.answer-content {
  word-break: break-all;
  color: #303133;
  text-align: justify;
  padding: 10px 0;
}
</style>
